import type {ProductFilterName, ProductFilterOption, ProductUrlFilters} from './types';
import type {UrlFilterSchema} from '@router';

export const PRODUCT_PAGE_SIZE = 10;
export const TOP_SELLER_VENDOR_BADGE = 'TYPE_TOP_SELLER_VENDOR';

export const PRODUCT_FILTER_SCHEMA: UrlFilterSchema<ProductUrlFilters> = {
  sort: 'string',
  badge: 'string',
  stock_status: 'string'
};

export const PRODUCT_FILTER_TITLES: Record<ProductFilterName, string> = {
  sort: 'مرتب‌سازی',
  badge: 'فروش',
  stock_status: 'موجودی'
};

export const PRODUCT_FILTER_OPTIONS: Record<ProductFilterName, ProductFilterOption[]> = {
  badge: [
    {label: 'بیشترین فروش شما', value: '1'},
    {label: 'کمترین فروش شما', value: '2'},
    {label: 'پرفروش منطقه', value: '3'},
    {label: 'کم‌فروش منطقه', value: '4'}
  ],
  sort: [
    {label: 'بیشترین فروش', value: '-top_seller'},
    {label: 'کمترین فروش', value: 'top_seller'},
    {label: 'بیشترین تخفیف', value: '-discount'},
    {label: 'کمترین تخفیف', value: 'discount'},
    {label: 'بیشترین قیمت', value: '-price'},
    {label: 'کمترین قیمت', value: 'price'},
    {label: 'بیشترین موجودی', value: '-stock'},
    {label: 'کمترین موجودی', value: 'stock'}
  ],
  stock_status: [
    {label: 'موجود', value: '1'},
    {label: 'ناموجود', value: '2'},
    {label: 'رو به اتمام', value: '3'}
  ]
};

export const PRODUCT_BADGE_LABELS: Record<string, string> = {
  TYPE_TOP_SELLER_VENDOR: 'بیشترین فروش شما',
  TYPE_TOP_SELLER_AREA: 'پرفروش منطقه',
  TYPE_BOTTOM_SELLER_VENDOR: 'کمترین فروش شما',
  TYPE_BOTTOM_SELLER_AREA: 'کم‌فروش منطقه',
  UNFAIR_PRICE: 'قیمت غیر منصفانه'
};
